// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-login-password_change',
    // #endregion
    // #region Data
    data: () => ({
        userID: "",
        userName: "",
        code: "",
        password1: "",
        password2: "",
        errorMessage: ""
    }),
    // #endregion
    // #region Computed
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
    },
    // #endregion
    // #region Constructor
    created() {
        this.userName = utils.decodeBase64(this.$route.query.userName);
        this.userID = utils.decodeBase64(this.$route.query.userId);
        this.code = this.$route.query.code;
    },
    // #endregion
    // #region Methods
    methods: {
        async OnExecute() {
            // #region Check
            if (utils.isEmpty(this.password1)) {
                return;
            }
            if (this.password1 != this.password2) {
                return;
            }
            // #endregion
            // #region Reset
            this.errorMessage = '';
            // #endregion
            // #region Run
            var tBody = {
                userID: this.userID,
                code: this.code,
                password: this.password1
            };
            try {
                // #region Change
                await appHost.api.post(`identity/profile/password-reset`, tBody);
                // #endregion
                // #region Login
                let tResult = await appHost.login.loginByUsername(this.userName, this.password1);
                {
                    // #region Error
                    if (!tResult.isSucceded) {
                        this.errorMessage = tResult.errorMessage;
                    }
                    // #endregion
                    // #region Url
                    else if (this.$route.query?.returnUrl || this.$route.query?.ReturnUrl) {
                        //Parse
                        let tUrl = decodeURIComponent((this.$route.query?.returnUrl ?? this.$route.query?.ReturnUrl));
                        //Special
                        window.location.href = tUrl;
                    }
                    // #endregion
                    // #region Push
                    else if (tResult.redirectUrl) {
                        this.$router.push(tResult.redirectUrl);
                    }
                    else if (this.$appHost.config.loggedInUrl) {
                        this.$router.push(this.$appHost.config.loggedInUrl);
                    }
                    else {
                        this.$router.push("/");
                    }
                    // #endregion
                }
                // #endregion                    
            }
            catch (e) {
                this.errorMessage = utils.getAxiosErrorMessage(e);
            }
            finally {
                this.isLoading = false;
            }
            // #endregion
        },
        OnBack() {
            this.$router.push({ path: '/login' });
        }
    }
    // #endregion
});
// #endregion
